export default __webpack_public_path__ + "static/media/landing-background.fc835673.png";